import supportBusiness from "../../services/supportBusiness"

export default {
  namespaced: true,
  state: {
    supportBusinesses: [],
    errorSupportBusiness: false
  },
  mutations: {
    REFRESH(state, supportBusinesses) {
      state.supportBusinesses = supportBusinesses
    },
    ERROR(state, errorSupportBusiness) {
      state.errorSupportBusiness = errorSupportBusiness
    }
  },
  actions: {
    REFRESH: async(context) => {
      const supportBusinesses = await supportBusiness.getList().then((response) => {
        let res;
        if (response.success) {
          res = response.businessSupports
          context.commit("ERROR", false)
        } else {
          res = []
          context.commit("ERROR", true)
        }
        return res
      }

      ).catch(
        () => {
          context.commit("ERROR", true)
          return []
        }
      )
      context.commit("REFRESH", supportBusinesses)
    },
  },
  getters: {
    supportBusinesses: state => state.supportBusinesses,
    errorSupportBusiness: state => state.errorSupportBusiness
  }
}
